// extracted by mini-css-extract-plugin
export default {"MenuContainer":"ESiRpUdm","Menu":"FAET5i9a"};